"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const R = __importStar(require("ramda"));
const SDKError_1 = require("./SDKError");
const codes_1 = require("./codes");
const hasParameter = R.ifElse(R.is(String), R.has, R.hasPath);
const stringifyPath = R.ifElse(R.is(String), path => path, R.join('.'));
exports.throwIfMissingRequiredParameters = (requiredParameterPaths, packageName, parameters = {}) => {
    requiredParameterPaths.forEach(parameterPath => {
        const isMissing = !hasParameter(parameterPath)(parameters);
        if (isMissing) {
            throw new SDKError_1.SDKError(codes_1.ERROR_CODES.MISSING_PARAMETER, packageName, `Missing parameter: ${stringifyPath(parameterPath)}`);
        }
    });
};
exports.showWarningIfDeprecatedParameters = (deprecatedParameterPaths, packageName, parameters = {}) => {
    deprecatedParameterPaths.forEach(parameterPath => {
        const isExist = hasParameter(parameterPath)(parameters);
        if (isExist) {
            // tslint:disable-next-line:no-console
            console.warn(`Deprecated parameter: ${stringifyPath(parameterPath)}. Please, replace it with appropriate API https://www.npmjs.com/package/${packageName}`);
        }
    });
};
//# sourceMappingURL=helpers.js.map